import styled from "styled-components";
import { WerfenColor, WerfenColorMid, SAPBadgeColor, White } from "../../../Constants/ColorChart";

export const Container = styled.div`
    width: 400px;
    overflow: hidden;
    position: absolute;
    top: 50px;
    right: 10px;
    padding: 4px;
    margin: -4px;
    box-shadow: 0 3px 10px -4px ${ SAPBadgeColor };
`;

export const TabBar = styled.div`
    display: flex;
    background: ${ WerfenColor };
`;

export const Tab = styled.button`
    flex: 1;
    padding: 10px;
    background: ${ ( props ) => ( props.active ? SAPBadgeColor : WerfenColorMid ) };
    border-bottom-color: ${ ( props ) => ( props.active ?  "transparent" : SAPBadgeColor )};
    border-bottom-style: solid;
    border-bottom-width: 3px;
    cursor: pointer;
    font-weight: bold;
    outline: none;
    color: ${ White };
    
    &.left {
        border-right-color :${ SAPBadgeColor }
        border-right-style: solid;
        border-right-width: 3px;
        &:hover {
            color: ${ ( props ) => ( props.active ? WerfenColorMid: SAPBadgeColor ) };
        }
    }
    &.right {
        border-left-color :${  SAPBadgeColor  }
        border-right-style: solid;
        border-right-width: 3px;
        &:hover {
            color: ${ ( props ) => ( props.active ? WerfenColorMid: SAPBadgeColor ) };
        }
    }
`;

export const Content = styled.div`
    padding: 15px;
    background: ${ WerfenColor }
`;

export const Item = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 4px;
    border-bottom: 1px solid ${ White };
    margin-bottom: 10px;
    color: ${ White };
    span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    span.item-name {
        padding:0 8px;
        width: calc(100% - 125px);
        text-align: left;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    };
    span.item-time {
        text-align: right;
        width: 100px;
    }
    span.item-download-link {
        text-align: right;
        width: 100px;
    }
`;
